(ns minorodata.connections.sources.tiktok
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::tiktok-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                "tiktok-oauth"
   :enabled           false
   :name              "Tiktok oAuth"
   :description       "TikTok For Business is where you can unleash your brand's creative side"
   :image-source      "tiktok.svg"
   :tags              ["marketing"]

   :preview-formatter (fn [source]
                        (if (:is-token-valid source)
                          (str "Authenticated by token")
                          [:span {:class "text-kleene-error-01"
                                  :title         "TOKEN EXPIRED"}
                           "AUTH TOKEN EXPIRED"]))

   :form              {:format-for-api
                       (fn format-for-api [{:keys [auth-credentials advertiser-id name description]}]
                         {:source-type "tiktok-oauth"
                          :name        name
                          :description description
                          :source      {:advertiser-id       advertiser-id
                                        :auth-credentials-id (:auth-credentials-id auth-credentials)
                                        :is-token-valid      (:is-token-valid auth-credentials)
                                        :has-third-leg       true}})

                       :format-for-inputs
                       (fn format-for-inputs [{:keys [source name description]}]
                         (let [{:keys [auth-credentials-id is-token-valid advertiser-id]} source]
                           {:name                name
                            :description         description
                            :advertiser-id       advertiser-id
                            :auth-credentials    (when (and (some? auth-credentials-id)
                                                            (some? is-token-valid))
                                                   {:auth-credentials-id auth-credentials-id
                                                    :is-token-valid      is-token-valid})
                            :auth-credentials-id auth-credentials-id
                            :is-token-valid      is-token-valid}))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate
                       (partial form-component/validate-form ::tiktok-form)

                       :id
                       :tiktok-oauth-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :input
                         :label      "Advertiser ID"
                         :name       :advertiser-id
                         :required   true
                         :value      ""}

                        {:block-type           :oauth
                         :label                "Tiktok Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://ads.tiktok.com/marketing_api/auth"
                         :params-processor     (fn [{:keys [app-id redirect-uri state scope response-type rid]}]
                                                 {:response_type response-type
                                                  :app_id        app-id
                                                  :rid           rid
                                                  :redirect_uri  redirect-uri
                                                  :state         state})

                         :response-processor (fn [data]
                                               (select-keys data [:auth-credentials-id :is-token-valid]))

                         :oauth-connector-type "tiktok"
                         :has-third-leg        true

                         :response-type        "code"
                         :app-id               "6955582889631154177"
                         :rid                  "w4n3a1ygi7"}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn format-for-api [{:keys [name description status action destination-table
                                                   report service data-level metric]}]
                         {:name          name
                          :description   description
                          :status        status
                          :output-tables [destination-table]
                          :config        {:extracts [{:action            action
                                                      :report            report
                                                      :destination-table destination-table
                                                      :service           service
                                                      :data-level        data-level
                                                      :metric            metric}]}})

                       :format-for-inputs
                       (fn format-for-inputs [{:extract/keys [name description status config source-id]}]
                         (let [extract (get-in config [:extracts 0])]
                           (merge
                            (select-keys extract [:report :action :destination-table :extract-type
                                                  :service :data-level :metric])
                            (app.utils/keep-non-nil-keys
                             {:name          name
                              :description   description
                              :status        status
                              :output-tables []
                              :source-id     source-id}))))

                       :validate
                       (constantly nil)

                       :id
                       :tiktok-oauth-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :form-value
                         :name       :source-id}

                        {:block-type :select
                         :label      "Service Type"
                         :name       :service
                         :options    [{:name "Auction Ads"  :value "auction-ads"}]
                         :required   true
                         :value      "auction-ads"}

                        {:block-type :select
                         :label      "Report Type"
                         :name       :report
                         :options    [{:name "Basic" :value "basic"}]
                         :required   true
                         :value      "basic"}

                        {:block-type :select
                         :label      "Data Level"
                         :name       :data-level
                         :options    [{:name "Auction Ad" :value "auction-ad"}
                                      {:name "Auction AdGroup" :value "auction-adgroup"}
                                      {:name "Auction Campaign" :value "auction-campaign"}
                                      {:name "Auction Advertiser" :value "auction-advertiser"}]
                         :required   true
                         :value      "auction-ad"}

                        {:block-type :select
                         :label      "Metrics"
                         :name       :metric
                         :options    [{:name "Base" :value "base"}
                                      {:name "In-App" :value "in-app"}]
                         :required   true
                         :value      "base"}

                        {:content "Basic Data, Video Play, Engagement, Attribution and Page Event Metrics"
                         :conditions [[:eq [:metric :value] "base"]]}

                        {:content "In-App Event Metrics"
                         :conditions [[:eq [:metric :value] "in-app"]]}

                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:eq [:action :value] "append"]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
